/** @flow */

import {
  GetAbsenceReasonsList,
  GetAbsenceReasonsListSuccess,
  GetAbsenceReasonsListError,
  NewAbsenceReason,
  ShowAddAbsenceReasonModal,
  UpdateAbsenceReasonDraft,
  GetAbsenceReasonActiveSuccess,
  GetAbsenceReasonSuccess,
  GetAbsenceReasonError,
  ResetAbsenceReason,
  ShowAbsenceReasonEditModal,
  ChangeAbsenceReasonsFilterState,
  ChangeAbsenceReasonsFilterType,
  ExportLiveAbsenceReasons,
  ExportLiveAbsenceReasonsSuccess,
  ExportLiveAbsenceReasonsError,
  AddNewAbsenceReason,
  AddNewAbsenceReasonSuccess,
  AddNewAbsenceReasonError,
  GetAbsenceReason,
  UpdateAbsenceReason,
  UpdateAbsenceReasonSuccess,
  UpdateAbsenceReasonError,
  GetAbsenceReasonSchemaSuccess,
  GetAbsenceReasonSchemaError,
} from "@modules/service/constants/actions";
import * as absenceReasonsReducers from "./reducers";
import initialState from "./state";
import type { AbsenceReasonsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AbsenceReasonsState = initialState, action: Object): AbsenceReasonsState => {
  const act = {
    [UpdateAbsenceReason]: absenceReasonsReducers.onUpdateAbsenceReason,
    [UpdateAbsenceReasonSuccess]: absenceReasonsReducers.onUpdateAbsenceReasonSuccess,
    [UpdateAbsenceReasonError]: absenceReasonsReducers.onUpdateAbsenceReasonError,
    [GetAbsenceReason]: absenceReasonsReducers.onGetAbsenceReason,
    [GetAbsenceReasonSuccess]: absenceReasonsReducers.onGetAbsenceReasonSuccess,
    [GetAbsenceReasonError]: absenceReasonsReducers.onGetAbsenceReasonError,
    [ResetAbsenceReason]: absenceReasonsReducers.onResetAbsenceReason,
    [AddNewAbsenceReason]: absenceReasonsReducers.onAddNewAbsenceReason,
    [AddNewAbsenceReasonSuccess]: absenceReasonsReducers.onAddNewAbsenceReasonSuccess,
    [AddNewAbsenceReasonError]: absenceReasonsReducers.onAddNewAbsenceReasonError,
    [ExportLiveAbsenceReasons]: absenceReasonsReducers.onExportLiveAbsenceReasons,
    [ExportLiveAbsenceReasonsSuccess]: absenceReasonsReducers.onExportLiveAbsenceReasonsSuccess,
    [ExportLiveAbsenceReasonsError]: absenceReasonsReducers.onExportLiveAbsenceReasonsError,
    [GetAbsenceReasonsList]: absenceReasonsReducers.onGetAbsenceReasonsList,
    [GetAbsenceReasonsListSuccess]: absenceReasonsReducers.onGetAbsenceReasonsListSuccess,
    [GetAbsenceReasonsListError]: absenceReasonsReducers.onGetAbsenceReasonsListError,
    [NewAbsenceReason]: absenceReasonsReducers.onNewAbsenceReason,
    [ShowAddAbsenceReasonModal]: absenceReasonsReducers.onShowAddAbsenceReasonModal,
    [UpdateAbsenceReasonDraft]: absenceReasonsReducers.onUpdateAbsenceReasonDraft,
    [GetAbsenceReasonActiveSuccess]: absenceReasonsReducers.onGetAbsenceReasonActiveSuccess,
    [GetAbsenceReasonError]: absenceReasonsReducers.onGetAbsenceReasonError,
    [ShowAbsenceReasonEditModal]: absenceReasonsReducers.onShowAbsenceReasonEditModal,
    [ChangeAbsenceReasonsFilterState]: absenceReasonsReducers.onChangeAbsenceReasonsFilterState,
    [ChangeAbsenceReasonsFilterType]: absenceReasonsReducers.onChangeAbsenceReasonsFilterType,
    [GetAbsenceReasonSchemaSuccess]: absenceReasonsReducers.onGetAbsenceReasonSchemaSuccess,
    [GetAbsenceReasonSchemaError]: absenceReasonsReducers.onGetAbsenceReasonSchemaError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
